/*eslint-disable*/
import React, { useState } from 'react'
import styles from './Breadcrumbs.module.scss'
import HomeIcon from '@mui/icons-material/Home';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Divider } from '@mui/material';
import { useNavigate } from 'react-router';
import { UTA_LINK } from './Breadcrumbs.constants';

const Breadcrumbs = ({ value ,extraLinks=[]}) => {
    const navigate = useNavigate()
    const [selectedMenu, setSelectedMenu] = useState(value ? value : 'Users / Create new')
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={styles.container}>
            <div onClick={() => navigate("/")} className={styles.breadcrumb}>
                <span className={styles.icon}><HomeIcon /></span>
                <span className={styles.label}>Home</span>
                <span className={styles.separator}><KeyboardArrowRightIcon sx={{color:"#5E504799"}}/></span>
            </div>
            <div className={styles.breadcrumb}>
                <span onClick={handleClick} className={styles.label}>{selectedMenu}</span>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem className={selectedMenu === 'Users / Create new' ?
                        styles.selectedMenu : styles.menu} onClick={() => {
                            setSelectedMenu('Users / Create new')
                            handleClose()
                            navigate("/create-user")
                        }}>Users / Create new</MenuItem>
                    <MenuItem className={selectedMenu === 'Users / View & Edit' ?
                        styles.selectedMenu : styles.menu} onClick={() => {
                            setSelectedMenu('Users / View & Edit')
                            handleClose()
                            navigate("/search-user")
                        }}>Users / View & Edit</MenuItem>
                    <Divider />
                    <MenuItem className={selectedMenu === 'Group / Create new' ?
                        styles.selectedMenu : styles.menu} onClick={() => {
                            setSelectedMenu('Group / Create new')
                            handleClose()
                            navigate("/create-group")
                        }}>Group / Create new</MenuItem>
                    <MenuItem className={selectedMenu === 'Group / View & Edit' ?
                        styles.selectedMenu : styles.menu} onClick={() => {
                            setSelectedMenu('Group / View & Edit')
                            handleClose()
                            navigate("/search-group")
                        }}>Group / View & Edit</MenuItem>
                    <Divider />
                    <MenuItem className={selectedMenu === 'Audits / Single User Activity' ?
                        styles.selectedMenu : styles.menu} onClick={() => {
                        setSelectedMenu('Audits / Single User Activity')
                        handleClose()
                        navigate("/user-activities")
                    }}>Audits / Single User Activity</MenuItem>
                    <MenuItem className={selectedMenu === 'Audits / Bulk Search' ?
                        styles.selectedMenu : styles.menu} onClick={() => {
                        setSelectedMenu('Audits / Bulk Search')
                        handleClose()
                        navigate("/bulk-users-activity")
                    }}>Audits / Bulk Search</MenuItem>
                    <Divider />
                    <MenuItem className={selectedMenu === 'Reports / View Reports' ?
                        styles.selectedMenu : styles.menu} onClick={() => {
                        handleClose()
                        window.open("/reports-tableau", '_blank')
                    }}>Reports / View Reports</MenuItem>
                    <MenuItem className={selectedMenu === 'Reports / Unable to Access?' ?
                        styles.selectedMenu : styles.menu} onClick={() => {
                        handleClose()
                        window.open(UTA_LINK, '_blank')
                    }}>Reports / Unable to Access?</MenuItem>
                    <Divider />
                    <MenuItem className={selectedMenu === 'User Profile' ?
                        styles.selectedMenu : styles.menu} onClick={() => {
                        setSelectedMenu('User Profile')
                        handleClose()
                        navigate("/user-profile")
                    }}>User Profile</MenuItem>

                </Menu>
                <span className={styles.separator}><UnfoldMoreIcon sx={{color:"#5E504799"}}/></span>
            </div>
            {
                extraLinks && extraLinks.length>0 &&
                extraLinks.map(link => (
                    <div className={styles.breadcrumb}>
                        <span className={styles.separator}><KeyboardArrowRightIcon sx={{color:"#5E504799"}} /></span>
                        <span style={{color:link.link?"black":"#564C47"}} onClick={()=>{
                            if(link.link){
                                navigate(link.link)
                            }
                        }} className={styles.label}>{link.label}</span>
                    </div>
                ))

            }

        </div>
    )
}
export default Breadcrumbs